module.exports = __webpack_public_path__ + "static/media/con_spa_deg_emp_cle.d98c4b0d.png";